import React, { useEffect, useState } from 'react';

import GetPaginatedResponse from '../../Api/CRM/Responses/PaginatedResponse';

import SiteApi from '../../Api/SiteApi/SiteApi';

import LoadThemeComponent from '../../base/LoadThemeComponent';
import { isPlayport } from '../../utils/template';
import NotificationIcon from '../default/NotificationIcon';

import Loader from '../loader/Loader';

import NotificationsList from './NotificationsList';
import { DatabaseNotification } from './types';

function NotificationBell() {
    const [notifications, setNotifications] = useState<DatabaseNotification[]>([]);
    const [unreadNotificationsCount, setUnreadNotificationsCount] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);

    function fetchUnreadedNotificationsCount() {
        SiteApi.get('notifications/count').then((response) => {
            setUnreadNotificationsCount(response.data);
            setLoading(false);
        });
    }

    function fetchNotifications() {
        SiteApi.get('notifications/list', { params: { page: 1 } }).then(
            ({ data }: { data: GetPaginatedResponse<DatabaseNotification> }) => {
                if (data.data.length) {
                    setNotifications([...notifications, ...data.data]);
                }
            }
        );
    }

    function sendWebNotification(notification: DatabaseNotification) {
        if (!Notification) {
            return;
        }

        if (Notification.permission !== 'granted') {
            Notification.requestPermission();
            return;
        }

        const webNotification = new Notification(notification.data.extra.short_text);

        webNotification.onclick = () => {
            window.location.href = notification.data.extra.route;
        };
    }

    useEffect(() => {
        fetchUnreadedNotificationsCount();

        SiteApi.get('account/id').then((response) => {
            window.Echo.private(`user.${response.data}`).notification((notification: DatabaseNotification) => {
                setNotifications((prevItems) => [notification, ...prevItems.slice(0, 2)]);
                sendWebNotification(notification);
                fetchUnreadedNotificationsCount();
            });

            fetchNotifications();
        });
    }, []);

    const handleMarkAllAsRead = async () => {
        try {
            const response = await SiteApi.markAllNotificationsAsRead();
            if (response.status === 204) {
                fetchUnreadedNotificationsCount();
                setNotifications([]);
            }
        } catch (error) {
            console.error('Error marking notifications as read:', error);
        }
    };

    const baseView = () => (
        <div className="dropdown">
            <button
                type="button"
                className={`btn btn-transparent btn-notification dropdown-toggle ${
                    isPlayport() ? '' : 'dropdown-toggle'
                } ${unreadNotificationsCount > 0 ? 'active-notification' : ''}`}
                data-toggle="dropdown"
                data-display="static"
            >
                <i className="fas fa-bell" />
                <div className="notification">{unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount}</div>
            </button>
            <NotificationsList notifications={notifications} />
        </div>
    );

    const defaultView = () => (
        <div className="notification-bell-container">
            <div className="dropdown">
                <button
                    type="button"
                    className="btn btn-transparent btn-notification dropdown-toggle"
                    data-toggle="dropdown"
                    data-display="static"
                >
                    <NotificationIcon
                        style={{
                            width: 'auto',
                            height: '20px',
                            fill: 'white',
                        }}
                    />
                    {unreadNotificationsCount > 0 && (
                        <div className="notification">
                            {unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount}
                        </div>
                    )}
                </button>
                <NotificationsList notifications={notifications} onMarkAllAsRead={handleMarkAllAsRead} />
            </div>
        </div>
    );

    return (
        <Loader
            isLoading={loading}
            elementToShow={() => <LoadThemeComponent defaultView={defaultView} baseView={baseView} />}
        />
    );
}

export default NotificationBell;
